var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtonIconOfferRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#C00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.072 21.465c-.72.713-1.882.713-2.598 0l-10.12-9.469c-.566-.53-1.24-1.532-1.289-2.305-.129-2.089-.037-6.09.026-8.21C.114.708.765.06 1.541.043c2.716-.064 8.47-.131 9.006.403l11.142 10.058c.716.714.067 2.52-.653 3.24l-6.964 7.72zM5.205 3.114c-.608-.603-1.59-.603-2.196 0-.606.606-.606 1.584 0 2.189.608.605 1.589.605 2.196 0 .605-.605.605-1.583 0-2.189z",
    transform: "translate(-364 -695) translate(364.647 695.75) matrix(-1 0 0 1 24 0) translate(1 1) matrix(-1 0 0 1 22 0)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtonIconOfferRed);
export default __webpack_public_path__ + "static/media/proton-icon-offer-red.bf1c53884c590cfd86a2cbf4a70b4408.svg";
export { ForwardRef as ReactComponent };